import React from 'react';
import validator from 'validator';
import AppVariables from "./AppVariables";
import Utils from "./Utils";

const SpecialCharacters = " !\"#$%&'()*+,-/:;<=>?[\\]^_`{|}~";

function containsSpecialCharacter(str) {

    for(let i = 0 ; i < str.length ; i++){
        if(SpecialCharacters.indexOf( str[i]) >= 0)
            return true;
    }

    return false;
}

const ErrorHint = (props) => {
    return props.error ? <p className="error-label" style={{marginTop: '4px'}}>{props.error}</p> : null;
};

const StatusError = props => {
    return  props.error ? <p className="alert-danger error-label" style={{padding: '10px'}}>{props.error}</p> : null;
};


export default {

    // Key name maps the rule
    required: {

        // Function to validate value
        // NOTE: value might be a number -> force to string
        rule: value => {
            return value !== undefined ? value.toString().trim() : false;
        },

        // Function to return hint
        // You may use current value to inject it in some way to the hint
        hint: (value) => {
            return <ErrorHint error={"Field is required"}/>
        }
    },

    username: {

        rule: value => {
            return value != undefined ? !(value.toString().trim().length < AppVariables.MinUsernameLength || isFinite(value)  ||  isFinite(value.toString()[0]) || containsSpecialCharacter(value.toString())  ) : false;
        },

        hint: value => {

            let error;
            if(value.length < AppVariables.MinUsernameLength){
                error = "Invalid username. Minimum length not met!";
            }
            else if(containsSpecialCharacter(value.toString())){
                error = "Username cannot contain special characters except @ and period. White spaces are not allowed!";
            }
            else if( isFinite(value.toString()) || isFinite(value.toString()[0]) ){
                error = "Username cannot be numeric or begin with a number"
            }


            return <ErrorHint error={error}/>
        }


    },

    userpassword:{

        rule: value =>{
            return value != undefined ? !(value.toString().trim().length < AppVariables.MinPasswordLength) : false;
        },

        hint: value =>{
            return <ErrorHint error="Invalid password. Minimum length not met!"/>
        }

    },

    activationCode: {

        rule: value => {
            return value != undefined ? AppVariables.ValidTokenLengths.indexOf(value.toString().trim().length) >= 0 : false
        },

        hint: value =>{
            return <ErrorHint error="Invalid activation code!"/>
        }

    },

    email: {

        rule: value => {
            return (value == "" || value == undefined) ?  true : validator.isEmail(value);
        },

        hint: value => {
            return value && <ErrorHint error={ `'${value}' isn't a valid email address.`}/>
        }

    },

    phone:{

        rule: value =>{
            return value != undefined ? Utils.validatePhoneNumber(value) : false
        },

        hint: value =>{
            return <ErrorHint error="Please enter a valid phone number"/>
        }

    },

    // This example shows a way to handle common task - compare two fields for equality
    password: {

        // rule function can accept argument:
        // components - components registered to Form mapped by name
        rule: (value, components) => {
            const password = components.password.state;
            const passwordConfirm = components.password_confirm.state;
            const isBothUsed = password
                && passwordConfirm
                && password.isUsed
                && passwordConfirm.isUsed;
            const isBothChanged = isBothUsed && password.isChanged && passwordConfirm.isChanged;

            if (!isBothUsed || !isBothChanged) {
                return true;
            }

            return password.value === passwordConfirm.value;
        },

        hint: () => <ErrorHint error="Passwords do not match"/>
    },


    // Define API rule to show hint after API error response
    'api-unique-value':{
        hint: value =>{
            return <ErrorHint error="Value already taken. Ensure the value is unique." />;
        }
    },

    'api-invalid-value':{
        hint: value =>{
            return <ErrorHint error="Invalid value. Ensure a valid value is entered."/>;
        }
    },

};




// WEBPACK FOOTER //
// ./src/common/ValidationHelper.js